import React, { useState } from 'react';
import Switch from 'react-switch';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';

// Styles for .companyStatusToggle live in App.css.
const ActiveStatusToggle = ({ name, isActive, canEdit, onChange, inactiveMessage }) => {
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [saving, setSaving] = useState(false);

    const label = isActive ? 'Active' : 'Inactive';

    if (!canEdit) {
        return <span>{label}</span>;
    }

    const handleToggle = async (checked) => {
        if (checked) {
            await onChange(true);
            return;
        }
        setConfirmOpen(true);
    };

    const closeModal = () => {
        if (!saving) setConfirmOpen(false);
    };

    const confirmInactive = async () => {
        setSaving(true);
        await onChange(false);
        setSaving(false);
        setConfirmOpen(false);
    };

    return (
        <>
            <span className={`companyStatusToggle ${isActive ? 'active' : 'inactive'}`}>
                <Switch
                    onChange={handleToggle}
                    checked={!!isActive}
                    className="switchBtn"
                    height={24}
                    width={48}
                    handleDiameter={20}
                    offHandleColor="#ffffff"
                    onHandleColor="#ffffff"
                    uncheckedIcon={false}
                    checkedIcon={false}
                />
                <span className="companyStatusLabel">{label}</span>
            </span>
            <Modal show={confirmOpen} onHide={closeModal} centered backdrop="static">
                <Modal.Body>
                    <h5 className="mb-3">Mark as Inactive?</h5>
                    <p>
                        Mark <strong>{name}</strong> as Inactive?{inactiveMessage ? ` ${inactiveMessage}` : ''}
                    </p>
                    <div className="d-flex justify-content-end mt-3">
                        <Button variant="light" className="border mr-2" onClick={closeModal} disabled={saving}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={confirmInactive} disabled={saving}>
                            Confirm
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

ActiveStatusToggle.propTypes = {
    name: PropTypes.string,
    isActive: PropTypes.bool,
    canEdit: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    inactiveMessage: PropTypes.string,
};

export default ActiveStatusToggle;
